import { render, staticRenderFns } from "./MultiMultipleChoicePure.vue?vue&type=template&id=3f3902f8&scoped=true&"
import script from "./MultiMultipleChoicePure.vue?vue&type=script&lang=js&"
export * from "./MultiMultipleChoicePure.vue?vue&type=script&lang=js&"
import style0 from "./MultiMultipleChoicePure.vue?vue&type=style&index=0&id=3f3902f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3902f8",
  null
  
)

export default component.exports